const Divider = ({ className, isVertical }) => {
    return (
        <div
            className={`bg-gray-50 ${
                isVertical ? "h-full w-[1px]" : "h-[1px] w-full"
            } ${className ?? ""}`}
        />
    );
};

export default Divider;
